import DropdownTemplateView from '../../../../DropdownTemplateView'
import {HierarchyLevels} from 'constants'
import $ from 'jquery'
import SimpleTwoOptionsMenu from '../../../../components/SimpleTwoOptionsMenu'

export default class RevokeMenu extends DropdownTemplateView {
    constructor() {
        super()

        this.onItemSelected = () => {}

        this.state = {
            hierarchyLevel: HierarchyLevels.TASK,
            assignTextsMap: {},
            revokeTextsMap: {},
        }

        this.onAnyStatePropertyChanged(['hierarchyLevel', 'assignTextsMap', 'revokeTextsMap'], (level) => {
            let grantTitle = this.state.assignTextsMap[level.hierarchyLevel]
            let revokeTitle = this.state.revokeTextsMap[level.hierarchyLevel]
            this.simpleMenu.setState({
                firstTitle: grantTitle,
                secondTitle: revokeTitle,
            })
        })
    }

    static getInstance() {
        return getInstance()
    }

    templateHtml() {
        return "<div class='chooseAccessMenuContainer'/>"
    }

    afterRender() {
        this.simpleMenu = new SimpleTwoOptionsMenu({
            additionalClass: 'chooseAccessMenu',
            onFirstOptionSelected: () => this.onItemSelected(true),
            onSecondOptionSelected: () => this.onItemSelected(false),
        }).init(this.$el)
    }

    setCallback(callback) {
        this.onItemSelected = callback
    }

    setOnHideCallback(callback) {
        this.onHideCallback = callback
    }

    onHide() {
        super.onHide()
        this.onHideCallback()
    }
}

let instance = null
const getInstance = () => {
    if (!instance) {
        instance = new RevokeMenu().init($('body'))
    }
    return instance
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/RevokeMenu.js